import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CheckoutMiddleware from 'yoda-checkout-components/lib/middlewares/CheckoutAnalyticsMiddleware';

const rootMiddleware = [CommonMiddleware, CheckoutMiddleware];

export default rootMiddleware;
